<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">
            <!-- Confirmation dialog for deleting equipment start-->
            <v-dialog v-model="showDeleteModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Delete Equipment Type</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showDeleteModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to delete this equipment type?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showDeleteModal=false;">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="deleteEquipment">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Equipment detail modal start -->
            <!-- Confirmation dialog for change the associating aggregator code-->
            <v-dialog v-model="showChangeAggregatorCodeModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Update Equipment Aggregator Codes</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showChangeAggregatorCodeModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        {{msgForAssociatedCodes}}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showChangeAggregatorCodeModal=false;getEquipments();">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="updateCodes(currentFormData)">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Equipment detail modal start -->
            <v-dialog v-model="showEquipmentDetail" max-width="60%" scrollable>
                <v-card>
                    <v-toolbar dark color="orange">
                        <v-toolbar-title>Equipment Type Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="showEquipmentDetail=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="equipmentDetails && Object.keys(equipmentDetails).length">
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Code</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{equipmentDetails.code}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{equipmentDetails.name}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Description</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1 textwrap">{{equipmentDetails.description}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Primary</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{equipmentDetails.primary ? "Yes" : "No"}}</div>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- Equipment detail modal end -->
            <!-- Confirmation dialog for deleting role end-->
            <v-flex lg12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Equipment Types</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn" v-if="permissionName=='all'" :to="{name:'AddAggregator'}">
                            <v-icon color="black">add</v-icon>Add Aggregator
                        </router-link>
                        &nbsp;
                        <router-link class="link-btn" v-if="permissionName=='all'" :to="{name:'AddEquipment'}">
                            <v-icon color="black">add</v-icon>Add Equipment Type
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0 table-inline-text">
                        <v-card-text>  
                            <v-text-field 
                                solo 
                                append-outer-icon="search" 
                                class="customTxt" 
                                placeholder="Type something to search..." 
                                v-model="search" 
                                hide-details
                            >
                            </v-text-field>
                        </v-card-text>
                        <v-data-table 
                            :disable-initial-sort="true" 
                            v-bind:headers="headers" 
                            :search="search" 
                            v-bind:items="equipments" 
                            :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" 
                            item-key="code"
                        >
                            <template slot="items" slot-scope="props" >
                                <td> {{props.item.code}} </td>
                                <td>
                                    <v-edit-dialog
                                        @cancel="cancel();"
                                        @save="saveNDValue(props.item.id,props.item.name,'name')"
                                        lazy
                                        large
                                        v-if="permissionName=='all'"
                                    >
                                        {{ props.item.name }}
                                        <v-text-field
                                            slot="input"
                                            autofocus
                                            label="Equipment Type"
                                            v-bind:value="props.item.name"
                                            v-model="props.item.name"
                                            v-validate="{required: props.item.name, max: 32, no_special_char: 'props.item.name'}" 
                                            data-vv-name="name"
                                            :maxlength="32" 
                                            :error-messages="errors.collect('name')"
                                        ></v-text-field>
                                    </v-edit-dialog>
                                    <template v-if="permissionName!='all'">
                                        {{ props.item.name }}
                                    </template>
                                </td>
                                <td>
                                    <v-edit-dialog
                                        @cancel="cancel();"
                                        @save="saveNDValue(props.item.id,props.item.description,'description')"
                                        lazy
                                        large
                                        v-if="permissionName=='all'"
                                    >
                                        {{(props.item.description && props.item.description.length>0)?props.item.description:notProvidedStr}}
                                        <v-textarea
                                            slot="input"
                                            auto-grow
                                            autofocus
                                            label="Description"
                                            v-bind:value="props.item.description"
                                            v-model="props.item.description"
                                            data-vv-name="description"
                                            :error-messages="errors.collect('description')"
                                        >
                                        </v-textarea>
                                    </v-edit-dialog>
                                </td>
                                <template v-if="aggregatorList && aggregatorList.length > 0">
                                    <td v-for="(aggregator,index) in aggregatorList" v-bind:key="index"> 
                                        <v-edit-dialog
                                            @cancel="cancel();"
                                            @save="saveAValue(props.item.id,props.item.code,aggregator.Id,equipments[props.index][aggregator['name']+'FinalCode'],'aggregator')"
                                            lazy
                                            large
                                            v-if="permissionName=='all'"
                                        >
                                            {{props.item[aggregator["name"]+"EquipmentName"].join(', ')}}
                                            <v-autocomplete
                                                slot="input"
                                                class="auotchoice"
                                                :menu-props="{'maxHeight':150}" 
                                                :v-model="`props.item[${aggregator['name']+'EquipmentCode'}]`"
                                                :items="props.item[aggregator['name']]"
                                                item-text="mapped_name" 
                                                item-value="Id"
                                                label="Select Code"
                                                v-bind:value="props.item[aggregator['name']+'EquipmentCode']"
                                                v-on:change="onEquipmentChange(props.index,aggregator['name'],$event)"
                                                multiple
                                                clearable
                                                dense
                                            >
                                                <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    <v-chip
                                                        data-vv-scope="form"
                                                        :selected="data.selected"
                                                        class="v-chip--select-multi"
                                                        @input="removeEquipmentTypeChip(props.index,aggregator['name'],data.item.Id)"
                                                        close
                                                    >
                                                        {{data.item.mapped_name}}
                                                    </v-chip>
                                                </template>
                                            </v-autocomplete>
                                        </v-edit-dialog>
                                    </td>
                                </template>
                                <td width="150px" class="text-xs-center">
                                    <v-btn class="remove-border" v-if="permissionName=='all' && props.item.code != 'VAN'" depressed outline icon fab dark color="orange" small @click="showDeleteModal=true; deleteEquipmentId=props.item.id">
                                        <v-icon>fa-trash</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import config from "../../config";
import util from "../../util";
import { setTimeout } from 'timers';
export default {
    mounted() {
        this.permissionName = this.$store.state.user ? this.$store.state.user.permissions.equipments : null;
    },
    async created(){
        const self = this;
        await self.getAggregatorList().then(result=>{
            self.aggregatorList = JSON.parse(JSON.stringify(result));
            self.aggregatorList.forEach(async function(aggregator){
                let aggregatorTmpObj = {
                    "text":aggregator.name,
                    "value":aggregator.name,
                    "width":config.dynamicAggregatorColumnWidth
                };
                self.aggregatorNameList.push(aggregator.name);
                self.headers.insert((self.headers.length-1),aggregatorTmpObj);
            });
            self.getEquipments();
        });
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        getAggregatorList() {
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            let  aggregratorList = [];
            return new Promise((resolve, reject) => {
                services.get("aggregators/list", {Authorization: "Bearer " + this.$store.state.user.token}).then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        aggregratorList = JSON.parse(JSON.stringify(res.data.data));
                        resolve(aggregratorList);
                    }else{
                        reject(aggregratorList);
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    reject(aggregratorList);
                });
            });
        },
        async getEquipments() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            await services.get("equipments/list", {Authorization: "Bearer " + this.$store.state.user.token}).then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self.getActualEquipment(res.data.data).then(response=>{
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self.equipments = response;
                    });
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        getActualEquipment(data){
            const self = this;
            return new Promise((resolve) => {
                data.forEach(function(equipment,index){
                    self.aggregatorNameList.forEach(async function(aggregatorName,aggregatorIndex){
                        data[index][aggregatorName] = Array();
                        data[index][aggregatorName+"EquipmentName"] = Array();
                        data[index][aggregatorName+"EquipmentCode"] = Array();
                        data[index][aggregatorName+"FinalCode"] = Array();
                        if(self.aggregatorList[aggregatorIndex].AggregatorCode.length > 0){
                            data[index][aggregatorName] = self.aggregatorList[aggregatorIndex].AggregatorCode;
                        }else{
                            data[index][aggregatorName] = [];
                        }   
                        data[index][aggregatorName+"EquipmentName"].push(config.notMappedStr);                     
                    });
                    if(equipment.AggregatorEquipment.length != 0){
                        let tmpAggregator = [];
                        equipment.AggregatorEquipment.forEach(async function(aggregator,aggregatorIndex){
                            let keyName1 = aggregator.Aggregator["name"]+'EquipmentCode';
                            let keyName2 = aggregator.Aggregator["name"]+'EquipmentName';
                            let keyName3 = aggregator.Aggregator["name"]+'FinalCode';
                            if(!tmpAggregator.includes(aggregator.Aggregator["name"])){
                                tmpAggregator.push(aggregator.Aggregator["name"]);
                                data[index][keyName1] = Array();
                                data[index][keyName2] = Array();
                                data[index][keyName3] = Array();
                            }
                            data[index][keyName1].push(aggregator.AggregatorCode);
                            data[index][keyName2].push(aggregator.AggregatorCode.mapped_name);
                            data[index][keyName3].push(aggregator.AggregatorCode.Id);
                        });
                    }
                });
                resolve(data);
            });
        },
        deleteEquipment() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.showDeleteModal = false;
            services
                .delete("equipments/delete", {
                    id: self.deleteEquipmentId
                }, {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    if (res.status === 200) {
                        self._showToast(res.data.message);
                        self.getEquipments();
                    }
                    self.deleteEquipmentId = null;
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                    self.deleteEquipmentId = null;
                });
        },
        saveNDValue(recordId,fieldValue,fieldName) {
            const self = this,
                wApp = window.getApp;
            const formData = {};
            formData["id"] = recordId;
            formData[fieldName] = fieldValue;
            services.put("equipments/inline-edit", formData, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self._showToast(res.data.message,config.successMsgColorStr);
                    self.getEquipments();
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
                self.getEquipments();
            });
        },
        saveAValue(recordId,equipmentCode,aggregatorId,fieldValue,fieldName) {
            const self = this,
                wApp = window.getApp;
            const formData = {};
            self.currentFormData = {};
            formData["id"] = recordId.toString();
            formData["code"] = equipmentCode;
            formData["aggregator"] = [];            
            let tmpObject = {
                "aggregator_id":aggregatorId.toString(),
                "aggregator_code_id":fieldValue.join(',').toString()
            }
            let tmpArray = [];
            tmpArray.push(tmpObject);
            formData["aggregator"] = JSON.stringify(tmpArray);
            services.put("equipments/inline-edit", formData, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    if(res.data.is_error){
                        self.msgForAssociatedCodes = res.data.message;
                        self.showChangeAggregatorCodeModal = true;
                        self.currentFormData = Object.assign({},formData);
                    }else{
                        self._showToast(res.data.message,config.successMsgColorStr);
                        self.getEquipments();
                    }
                }else{
                    self._showToast(res.data.message,config.errMsgColorStr);
                    self.getEquipments();
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
                self.getEquipments();
            });
        },
        cancel () {
            const self = this;
            //self._showToast(config.cancelledMsg, config.errMsgColorStr);
            self.getEquipments();
        },
        updateCodes(formData) {
            const self = this,
                wApp = window.getApp;
            self.showChangeAggregatorCodeModal=false;
            services.put("equipments/force-inline-edit", formData, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self._showToast(res.data.message,config.successMsgColorStr);
                    self.getEquipments();
                }else{
                    self._showToast(res.data.message,config.errMsgColorStr);
                    self.getEquipments();
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
                self.getEquipments();
            });
        },
        removeEquipmentTypeChip(index,aggregratorName,id) {
            const self = this;
            self.equipments[index][aggregratorName+"EquipmentCode"].splice(self.equipments[index][aggregratorName+"FinalCode"].indexOf(id),1);
            self.equipments[index][aggregratorName+"EquipmentName"].splice(self.equipments[index][aggregratorName+"FinalCode"].indexOf(id),1);
            self.equipments[index][aggregratorName+"FinalCode"].splice(self.equipments[index][aggregratorName+"FinalCode"].indexOf(id),1);
        },
        onEquipmentChange(index,aggregratorName,event) {
            const self = this;
            console.log(index,aggregratorName,event);
            self.equipments[index][aggregratorName+"FinalCode"] = Array();
            if(event.length > 0){
                event.forEach(async function(aggregatorEquipmentCode){
                    await self.equipments[index][aggregratorName+"FinalCode"].push(aggregatorEquipmentCode);
                });
            }
        }
    },
    data() {
        return {
            notProvidedStr:config.notProvidedStr,
            aggregatorList:[],
            aggregatorNameList:[],
            search: "",
            deleteEquipmentId: null,
            showDeleteModal: false,
            showChangeAggregatorCodeModal:false,
            showEquipmentDetail: false,
            equipmentDetails: {},
            permissionName: null,
            msgForAssociatedCodes:'',
            headers: [{
                    text: "LoadMax Code",
                    value: "code",
                    fixed: true
                },
                {
                    text: "Equipment Type",
                    value: "name"
                },
                {
                    text: "Description",
                    value: "description"
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false,
                    align: 'center'
                }
            ],
            equipments: [],
            breadcrumbs: [{
                    name: 'Dashboard',
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: 'Reporting',
                    to: "/comingsoon",
                    disabled: false
                },
                {
                    name: 'Equipment Types',
                    disabled: true
                }
            ],
            currentFormData:{}

        };
    }
};
Array.prototype.insert = function ( index, item ) {
    this.splice( index, 0, item );
};
</script>
<style>
.no-underline {
    text-decoration: none;
}
.v-btn.remove-border {
    border:none !important;
}
.table-inline-text table.v-table tbody td, .table-inline-text table.v-table tbody th {
    height: auto !important;
    min-height: 48px !important;
}
.v-autocomplete__content.v-menu__content{
    z-index:102 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/equipment/List.vue